/* Gotcha theme behaviours. Vanilla JS. Ports the prototype interactions and
   binds them to Shopify data (Cart AJAX + Section Rendering API). */
(function () {
  'use strict';
  var theme = window.theme || {};
  var routes = theme.routes || {};
  var strings = theme.strings || {};

  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };

  function announce(message) {
    var notice = $('[data-notice]');
    if (!notice || !message) return;
    var label = notice.querySelector('.pill-label');
    if (label) label.textContent = message;
    notice.classList.add('is-visible');
    clearTimeout(window.__noticeTimer);
    window.__noticeTimer = setTimeout(function () { notice.classList.remove('is-visible'); }, 1800);
  }

  /* -------------------------------------------------------------------- */
  /* Storefront overlays (search / cart / menu)                           */
  /* -------------------------------------------------------------------- */
  var activePanel = null;
  var returnFocus = null;
  var closeTimer = null;

  function openPanel(name) {
    var overlay = $('[data-storefront-overlay]');
    var panel = overlay && overlay.querySelector('[data-storefront-panel="' + name + '"]');
    if (!overlay || !panel) return;
    clearTimeout(closeTimer);
    returnFocus = document.activeElement;
    activePanel = name;

    $$('[data-storefront-panel]', overlay).forEach(function (item) {
      item.hidden = item !== panel;
      item.classList.remove('is-open');
    });
    overlay.hidden = false;
    var app = $('.app');
    if (app) app.setAttribute('inert', '');
    document.body.classList.add('is-storefront-panel-open');
    $$('[data-opens-storefront-panel]').forEach(function (trigger) {
      trigger.setAttribute('aria-expanded', String(trigger.dataset.opensStorefrontPanel === name));
    });

    requestAnimationFrame(function () {
      overlay.classList.add('is-open');
      panel.classList.add('is-open');
      setTimeout(function () {
        var focusTarget = name === 'search'
          ? panel.querySelector('[data-overlay-search-input]')
          : panel.querySelector('[data-overlay-close]');
        if (focusTarget) focusTarget.focus();
      }, 80);
    });
  }

  function closePanel() {
    if (!activePanel) return;
    var overlay = $('[data-storefront-overlay]');
    var panel = overlay && overlay.querySelector('[data-storefront-panel="' + activePanel + '"]');
    if (overlay) overlay.classList.remove('is-open');
    if (panel) panel.classList.remove('is-open');
    var app = $('.app');
    if (app) app.removeAttribute('inert');
    document.body.classList.remove('is-storefront-panel-open');
    $$('[data-opens-storefront-panel]').forEach(function (t) { t.setAttribute('aria-expanded', 'false'); });
    var rf = returnFocus;
    activePanel = null;
    closeTimer = setTimeout(function () {
      if (overlay) overlay.hidden = true;
      if (panel) panel.hidden = true;
    }, 320);
    if (rf && rf.focus) rf.focus();
  }

  function initOverlayTriggers() {
    // Cart triggers
    $$('.site-nav__right a[href$="/cart"], [data-opens-storefront-panel="cart"]').forEach(function (link) {
      if (link.dataset.overlayBound) return;
      link.dataset.overlayBound = '1';
      link.dataset.opensStorefrontPanel = 'cart';
      link.setAttribute('aria-controls', 'storefront-cart-panel');
      link.setAttribute('aria-haspopup', 'dialog');
      link.setAttribute('aria-expanded', 'false');
      link.addEventListener('click', function (e) {
        if (theme.cartType !== 'drawer') return;
        if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
        e.preventDefault();
        openPanel('cart');
      });
    });
    // Search triggers
    $$('.search-link, [data-opens-storefront-panel="search"]').forEach(function (link) {
      if (link.dataset.overlayBound) return;
      link.dataset.overlayBound = '1';
      link.dataset.opensStorefrontPanel = 'search';
      link.setAttribute('aria-controls', 'storefront-search-panel');
      link.setAttribute('aria-haspopup', 'dialog');
      link.addEventListener('click', function (e) {
        if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
        e.preventDefault();
        openPanel('search');
      });
    });
    // Menu toggle
    $$('[data-opens-storefront-panel="menu"], .site-nav__menu-toggle').forEach(function (btn) {
      if (btn.dataset.overlayBound) return;
      btn.dataset.overlayBound = '1';
      btn.removeAttribute('hidden');
      btn.addEventListener('click', function () { openPanel('menu'); });
    });
    populateMenuDrawer();
  }

  function populateMenuDrawer() {
    var host = $('[data-menu-links]');
    var nav = $('.site-nav__left');
    if (!host || !nav || host.children.length) return;
    var links = $$('a', nav).map(function (a) {
      return '<a href="' + a.getAttribute('href') + '">' + a.textContent.trim() + '</a>';
    });
    host.innerHTML = links.join('');
  }

  function initOverlayEvents() {
    var overlay = $('[data-storefront-overlay]');
    if (!overlay || overlay.dataset.eventsBound) return;
    overlay.dataset.eventsBound = '1';
    overlay.addEventListener('click', function (e) {
      if (e.target.closest('[data-overlay-close]')) { closePanel(); return; }
      handleDrawerCartClick(e);
    });
    document.addEventListener('keydown', function (e) {
      if (!activePanel) return;
      if (e.key === 'Escape') { e.preventDefault(); closePanel(); return; }
      if (e.key !== 'Tab') return;
      var panel = overlay.querySelector('[data-storefront-panel="' + activePanel + '"]');
      if (!panel) return;
      var focusable = $$('a[href], button:not([disabled]), input:not([disabled]), textarea, select', panel)
        .filter(function (el) { return el.offsetParent !== null; });
      if (!focusable.length) return;
      var first = focusable[0], last = focusable[focusable.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
  }

  /* -------------------------------------------------------------------- */
  /* Cart (Cart AJAX API + Section Rendering)                             */
  /* -------------------------------------------------------------------- */
  function cartSectionsToRender() {
    var ids = ['storefront-overlays'];
    var cartSection = $('[data-section-type="cart"]');
    if (cartSection && cartSection.dataset.sectionId) ids.push(cartSection.dataset.sectionId);
    return ids;
  }

  function updateFromSections(sectionsData) {
    if (!sectionsData) return;
    var parser = new DOMParser();
    Object.keys(sectionsData).forEach(function (id) {
      var html = sectionsData[id];
      if (!html) return;
      var doc = parser.parseFromString(html, 'text/html');
      if (id === 'storefront-overlays') {
        var newLines = doc.querySelector('[data-cart-drawer-lines]');
        var curLines = $('[data-cart-drawer-lines]');
        if (newLines && curLines) curLines.innerHTML = newLines.innerHTML;
        var newSummary = doc.querySelector('[data-cart-drawer-summary]');
        var curSummary = $('[data-cart-drawer-summary]');
        if (newSummary && curSummary) { curSummary.innerHTML = newSummary.innerHTML; curSummary.hidden = newSummary.hidden; }
      } else {
        // main cart section
        var newRoot = doc.querySelector('[data-cart-lines]');
        var curRoot = $('[data-cart-lines]');
        if (newRoot && curRoot) curRoot.innerHTML = newRoot.innerHTML;
        var newTotal = doc.querySelector('[data-cart-total]');
        var curTotal = $('[data-cart-total]');
        if (newTotal && curTotal) curTotal.textContent = newTotal.textContent;
      }
    });
  }

  function refreshCartCount(count) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = count; });
  }

  function cartRequest(url, body) {
    body.sections = cartSectionsToRender().join(',');
    body.sections_url = window.location.pathname;
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }

  function afterCartChange(data, message) {
    if (typeof data.item_count === 'number') refreshCartCount(data.item_count);
    updateFromSections(data.sections);
    if (message) announce(message);
  }

  function addToCart(form, button) {
    var formData = new FormData(form);
    if (!formData.get('id')) { announce(strings.chooseOption || 'Select an option'); return; }
    var body = {
      id: formData.get('id'),
      quantity: Number(formData.get('quantity') || 1),
      sections: cartSectionsToRender().join(','),
      sections_url: window.location.pathname
    };
    if (button) button.classList.add('is-loading');
    fetch(routes.cartAdd, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) { announce(data.description || strings.cartError); return; }
        updateFromSections(data.sections);
        return fetch(routes.cart + '.js').then(function (r) { return r.json(); }).then(function (cart) {
          refreshCartCount(cart.item_count);
          announce(strings.addedToCart);
          if (theme.cartType === 'drawer') openPanel('cart');
        });
      })
      .catch(function () { announce(strings.cartError); })
      .then(function () { if (button) button.classList.remove('is-loading'); });
  }

  function changeLine(line, quantity) {
    return cartRequest(routes.cartChange, { line: line, quantity: quantity }).then(function (data) {
      afterCartChange(data);
      return data;
    }).catch(function () { announce(strings.cartError); });
  }

  function handleDrawerCartClick(e) {
    var itemNode = e.target.closest('[data-drawer-cart-id]');
    if (!itemNode) return;
    var line = Number(itemNode.dataset.line);
    var qtyEl = itemNode.querySelector('[data-quantity]');
    var qty = qtyEl ? Number(qtyEl.textContent) : 1;
    if (e.target.closest('[data-drawer-cart-remove]')) { changeLine(line, 0); return; }
    if (e.target.closest('[data-drawer-cart-plus]')) { changeLine(line, qty + 1); return; }
    if (e.target.closest('[data-drawer-cart-minus]')) { changeLine(line, Math.max(0, qty - 1)); return; }
  }

  function initAddToCartForms() {
    $$('[data-type="add-to-cart-form"]').forEach(function (form) {
      if (form.dataset.bound) return;
      form.dataset.bound = '1';
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        addToCart(form, form.querySelector('[data-add-to-cart]'));
      });
    });
  }

  function initCartPage() {
    var page = $('[data-section-type="cart"]');
    if (!page || page.dataset.bound) return;
    page.dataset.bound = '1';
    page.addEventListener('click', function (e) {
      var row = e.target.closest('[data-cart-id]');
      if (!row) return;
      var line = Number(row.dataset.line);
      var input = row.querySelector('[data-quantity-input]');
      var qty = input ? Number(input.value) : 1;
      if (e.target.closest('[data-cart-remove]')) { e.preventDefault(); changeLine(line, 0); }
      else if (e.target.closest('[data-cart-plus]')) { changeLine(line, qty + 1); }
      else if (e.target.closest('[data-cart-minus]')) { changeLine(line, Math.max(0, qty - 1)); }
    });
    page.addEventListener('change', function (e) {
      var input = e.target.closest('[data-quantity-input]');
      if (!input) return;
      changeLine(Number(input.dataset.line), Math.max(0, Number(input.value)));
    });
  }

  /* -------------------------------------------------------------------- */
  /* Quantity steppers (generic)                                          */
  /* -------------------------------------------------------------------- */
  function initQuantitySteppers(ctx) {
    $$('[data-qty-minus], [data-qty-plus]', ctx).forEach(function (button) {
      if (button.dataset.bound) return;
      button.dataset.bound = '1';
      button.addEventListener('click', function () {
        var wrap = button.closest('.quantity');
        var input = wrap && wrap.querySelector('input');
        if (!input) return;
        var next = Math.max(Number(input.min || 1), Number(input.value || 1) + (button.hasAttribute('data-qty-plus') ? 1 : -1));
        input.value = next;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  }

  /* -------------------------------------------------------------------- */
  /* Product variant selection + gallery                                  */
  /* -------------------------------------------------------------------- */
  function initProduct(root) {
    root = root || document;
    $$('[data-product-root]', root).forEach(function (product) {
      if (product.dataset.bound) return;
      product.dataset.bound = '1';
      var variantsScript = product.querySelector('[data-variants]');
      var variants = [];
      try { variants = JSON.parse(variantsScript.textContent); } catch (e) {}
      // Placeholder shown next to the colour name before/when nothing is chosen.
      var selLabel0 = product.querySelector('[data-selected-option]');
      var selectPrompt = selLabel0 ? selLabel0.textContent.trim() : '';

      function selectedOptions() {
        var opts = [];
        $$('[data-option-group]', product).forEach(function (group) {
          var pos = Number(group.dataset.optionPosition);
          var active = group.querySelector('[data-option][aria-pressed="true"], [data-option].is-selected');
          if (active) opts[pos - 1] = active.dataset.optionValue;
        });
        return opts;
      }

      function findVariant(opts) {
        return variants.find(function (v) {
          return v.options.every(function (o, i) { return o === opts[i]; });
        });
      }

      function updateVariant() {
        var opts = selectedOptions();
        // Resolve the variant early so the gallery filter can prefer its
        // featured media when picking the active image for the chosen colour.
        var earlyVariant = findVariant(opts);
        product.__variantFeaturedMediaId = (earlyVariant && earlyVariant.featured_media) ? earlyVariant.featured_media.id : null;
        var idInput = product.querySelector('[data-variant-id]');
        var addBtn = product.querySelector('[data-add-to-cart]');
        var addText = product.querySelector('[data-add-to-cart-text]');
        var selectedLabel = product.querySelector('[data-selected-option]');
        var swatchWrap = product.querySelector('.color-swatches');
        var activeSw = swatchWrap && swatchWrap.querySelector('[data-option][aria-pressed="true"], [data-option].is-selected');

        // Colour label + gallery follow the swatch state, even before a full
        // variant resolves (so deselecting a colour resets both).
        if (swatchWrap) {
          if (activeSw) {
            if (selectedLabel) selectedLabel.textContent = activeSw.dataset.optionValue;
            filterGalleryByColor(product, activeSw.dataset.optionValue);
          } else {
            if (selectedLabel) selectedLabel.textContent = selectPrompt;
            clearGalleryColor(product);
          }
        }

        // No colour chosen on a colour product: back to the initial prompt state.
        if (swatchWrap && !activeSw) {
          if (idInput) idInput.value = '';
          if (addBtn) addBtn.disabled = true;
          if (addText) addText.textContent = strings.chooseOption || selectPrompt || 'Select';
          return;
        }

        var variant = findVariant(opts);
        if (!variant) {
          if (addBtn) { addBtn.disabled = true; }
          if (addText) addText.textContent = strings.soldOut || 'Unavailable';
          return;
        }
        if (idInput) idInput.value = variant.id;
        if (addBtn) addBtn.disabled = !variant.available;
        if (addText) addText.textContent = variant.available ? (strings.addToCart || 'Add to cart') : (strings.soldOut || 'Sold out');
        // price
        var priceContainer = product.querySelector('[data-price-container]');
        if (priceContainer && variant.price != null) {
          var cur = priceContainer.querySelector('[data-price]');
          if (cur) cur.textContent = formatMoney(variant.price);
          var cmp = priceContainer.querySelector('[data-compare-price]');
          if (cmp) cmp.textContent = variant.compare_at_price ? formatMoney(variant.compare_at_price) : '';
        }
        // sku / availability
        var sku = product.querySelector('[data-variant-sku]');
        if (sku) sku.textContent = variant.sku || '';
        var avail = product.querySelector('[data-variant-availability]');
        if (avail) avail.textContent = variant.available ? (strings.inStock || 'In stock') : (strings.soldOut || 'Sold out');
        // Single-media products (no colour swatches): swap to the variant image.
        // Colour products already had their gallery filtered above.
        if (!swatchWrap && variant.featured_media) {
          showMedia(product, variant.featured_media.id);
        }
        // URL
        if (variant.id && history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          history.replaceState({}, '', url.toString());
        }
      }

      product.addEventListener('click', function (e) {
        var opt = e.target.closest('[data-option]');
        if (opt && product.contains(opt)) {
          // Colour swatches toggle: clicking the chosen colour again clears the
          // selection (back to "no colour", every image shown). Other options
          // stay single-select — one value always remains chosen.
          var isSwatch = !!opt.closest('.color-swatches');
          var wasSelected = opt.getAttribute('aria-pressed') === 'true' || opt.classList.contains('is-selected');
          var group = opt.closest('[data-option-group], [role="radiogroup"]');
          if (group) {
            $$('[data-option]', group).forEach(function (o) { o.setAttribute('aria-pressed', 'false'); o.setAttribute('aria-checked', 'false'); o.classList.remove('is-selected'); });
          }
          if (!(isSwatch && wasSelected)) {
            opt.setAttribute('aria-pressed', 'true');
            opt.setAttribute('aria-checked', 'true');
            opt.classList.add('is-selected');
          }
          updateVariant();
        }
        var thumb = e.target.closest('[data-media-thumb]');
        if (thumb) showMedia(product, thumb.dataset.mediaThumb);
      });

      // keyboard for swatches/pills
      product.addEventListener('keydown', function (e) {
        var opt = e.target.closest('[data-option]');
        if (!opt) return;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') { e.preventDefault(); var n = opt.nextElementSibling; if (n) n.focus(); }
        if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') { e.preventDefault(); var p = opt.previousElementSibling; if (p) p.focus(); }
      });
      $$('[data-option]', product).forEach(function (o) { if (!o.hasAttribute('tabindex')) o.tabIndex = 0; });

      // Initial gallery state: filter to the pre-selected colour (no-op unless
      // the merchant has assigned per-colour images to the variants).
      var initSwatch = product.querySelector('.color-swatches [data-option][aria-pressed="true"], .color-swatches [data-option].is-selected');
      if (initSwatch) filterGalleryByColor(product, initSwatch.dataset.optionValue);
      else layoutGallery(product);
    });
  }

  /* -------------------------------------------------------------------- */
  /* Colour-based gallery media grouping                                  */
  /* Media are tagged in their ALT text ([color:red] / [color:red,blue]); */
  /* Liquid parses that into data-media-colors / data-media-global. Here   */
  /* we only compare pre-normalised strings — no colour names hardcoded.   */
  /* -------------------------------------------------------------------- */
  function normalizeColorValue(v) {
    return String(v == null ? '' : v).toLowerCase().trim().replace(/\s+/g, '-').replace(/-+/g, '-');
  }
  function mediaColorsOf(fig) {
    var raw = fig.getAttribute('data-media-colors');
    if (!raw) return [];
    return raw.split(',').map(function (s) { return s.trim(); }).filter(Boolean);
  }
  function mediaIsGlobal(fig) { return fig.getAttribute('data-media-global') === 'true'; }
  function mediaMatchesColor(fig, want) { return mediaColorsOf(fig).indexOf(want) !== -1; }
  function mediaExactSingle(fig, want) {
    var c = mediaColorsOf(fig);
    return c.length === 1 && c[0] === want;
  }

  // Show media tagged with the selected colour (plus untagged "global" media);
  // hide media tagged only for other colours. Never leaves the gallery empty:
  // if the colour has no tagged media, fall back to globals, then to all.
  function filterGalleryByColor(product, color) {
    var gallery = product.querySelector('.gallery');
    if (!gallery || gallery.getAttribute('data-color-filter') === 'false') return;
    var figs = $$('.gallery figure', gallery);
    if (!figs.length) return;
    var want = normalizeColorValue(color);
    if (!want) { clearGalleryColor(product); return; }

    // No colour-tagged media anywhere → nothing to group; leave the gallery
    // exactly as it was (untouched masonry, every image visible).
    var anyTagged = figs.some(function (f) { return mediaColorsOf(f).length > 0; });
    if (!anyTagged) { clearGalleryColor(product); return; }

    var showGlobals = gallery.getAttribute('data-color-filter-globals') !== 'false';
    var hasMatch = figs.some(function (f) { return mediaMatchesColor(f, want); });
    var anyGlobal = figs.some(mediaIsGlobal);

    figs.forEach(function (fig) {
      var visible;
      if (hasMatch) {
        visible = mediaMatchesColor(fig, want) || (mediaIsGlobal(fig) && showGlobals);
      } else if (anyGlobal) {
        visible = mediaIsGlobal(fig);           // no colour media -> globals only
      } else {
        visible = true;                          // nothing to fall back on -> show all
      }
      fig.hidden = !visible;
    });
    gallery.classList.add('has-color-active');
    markPrimaryMedia(product, want);
    layoutGallery(product);
  }

  // Choose (and gently reveal) the "primary" media among the visible set.
  // Priority: selected variant's featured media -> exact single-colour tagged
  // -> any tagged match -> first global -> first visible.
  function markPrimaryMedia(product, want) {
    var gallery = product.querySelector('.gallery');
    if (!gallery) return;
    var visible = $$('.gallery figure', gallery).filter(function (f) { return !f.hidden; });
    if (!visible.length) return;
    var vfmId = product.__variantFeaturedMediaId;
    var primary =
      (vfmId && visible.filter(function (f) { return String(f.dataset.mediaId) === String(vfmId); })[0]) ||
      visible.filter(function (f) { return mediaExactSingle(f, want); })[0] ||
      visible.filter(function (f) { return mediaMatchesColor(f, want); })[0] ||
      visible.filter(mediaIsGlobal)[0] ||
      visible[0];
    visible.forEach(function (f) { f.classList.toggle('is-color-active', f === primary); });
  }

  // Lay out the visible gallery: first visible figure spans full width ("lead"),
  // the rest fall into the 2-column grid. Re-run whenever visibility changes.
  function layoutGallery(product) {
    var gallery = product.querySelector('.gallery');
    if (!gallery) return;
    var figs = $$('.gallery figure', gallery);
    var lead = null;
    figs.forEach(function (f) { if (!f.hidden && !lead) lead = f; });
    figs.forEach(function (f) { f.classList.toggle('gallery__lead', f === lead); });
  }

  // Reset the gallery to its unfiltered state (every image shown) — used when a
  // colour is deselected.
  function clearGalleryColor(product) {
    var gallery = product.querySelector('.gallery');
    $$('.gallery figure', product).forEach(function (fig) {
      fig.hidden = false;
      fig.classList.remove('is-color-active');
    });
    if (gallery) gallery.classList.remove('has-color-active');
    layoutGallery(product);
  }

  function showMedia(product, mediaId) {
    $$('[data-media-id]', product).forEach(function (fig) {
      var match = String(fig.dataset.mediaId) === String(mediaId);
      fig.hidden = !match;
      fig.classList.toggle('is-active', match);
    });
    $$('[data-media-thumb]', product).forEach(function (t) {
      var match = String(t.dataset.mediaThumb) === String(mediaId);
      t.classList.toggle('is-active', match);
      t.setAttribute('aria-pressed', String(match));
    });
  }

  function formatMoney(cents) {
    var fmt = theme.moneyFormat || '${{amount}}';
    var value = (cents / 100).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    var valueNoDecimals = Math.round(cents / 100).toLocaleString();
    return fmt
      .replace(/\{\{\s*amount\s*\}\}/g, value)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, valueNoDecimals)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, value)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, valueNoDecimals);
  }

  /* -------------------------------------------------------------------- */
  /* Product card colour swatches                                         */
  /* Hover/focus = image preview, click/Enter = persistent selection      */
  /* (media + price + product link + ?variant= URL). Event-delegated once, */
  /* so it survives Theme Editor section reloads and scales to many cards. */
  /* -------------------------------------------------------------------- */
  var CARD = '[data-product-card]';
  var cardsDelegated = false;

  function cardImg(card) { return card.querySelector('[data-product-media]'); }

  function cacheCardMedia(card) {
    var img = cardImg(card);
    if (img && !card.__origMedia) {
      card.__origMedia = { src: img.getAttribute('src'), srcset: img.getAttribute('srcset') || '' };
    }
  }

  function applyCardMedia(card, src) {
    var img = cardImg(card);
    if (!img) return;
    cacheCardMedia(card);
    if (src) {
      // Drop srcset so the browser can't re-pick a candidate from the old set.
      img.removeAttribute('srcset');
      img.setAttribute('src', src);
    } else if (card.__origMedia) {
      if (card.__origMedia.srcset) img.setAttribute('srcset', card.__origMedia.srcset);
      else img.removeAttribute('srcset');
      img.setAttribute('src', card.__origMedia.src);
    }
  }

  function swatchMedia(sw) { return sw.getAttribute('data-variant-media') || ''; }
  function swatchDisabled(sw) { return sw.getAttribute('aria-disabled') === 'true'; }

  function selectedCardSwatch(card) {
    return card.querySelector('[data-swatch].is-selected') ||
           card.querySelector('[data-swatch][aria-checked="true"]');
  }

  // Media to show at rest: the chosen colour's image once the shopper has
  // picked one; otherwise the product's original featured image (so cards
  // look untouched until interacted with).
  function restingMedia(card) {
    if (card.dataset.userSelected) {
      var s = selectedCardSwatch(card);
      if (s) return swatchMedia(s);
    }
    return '';
  }

  function previewCardSwatch(sw) {
    var card = sw.closest(CARD);
    if (!card || card.dataset.swatchHoverPreview === 'false') return;
    // Suppress the secondary-image hover while previewing a colour.
    card.classList.add('is-previewing');
    var media = swatchMedia(sw);
    if (media) applyCardMedia(card, media); // no variant image -> keep current
  }

  function endCardPreview(card) {
    if (!card) return;
    card.classList.remove('is-previewing');
    applyCardMedia(card, restingMedia(card));
  }

  function updateCardPrice(card, sw) {
    if (card.dataset.swatchUpdatePrice === 'false') return;
    var priceEl = card.querySelector('[data-card-price]');
    if (!priceEl) return;
    var price = Number(sw.getAttribute('data-variant-price'));
    if (!isNaN(price)) priceEl.textContent = formatMoney(price);
    var wrap = card.querySelector('.product-card__price');
    var compareRaw = sw.getAttribute('data-variant-compare');
    var cmp = card.querySelector('[data-card-compare]');
    if (compareRaw) {
      if (!cmp) {
        cmp = document.createElement('s');
        cmp.setAttribute('data-card-compare', '');
        priceEl.parentNode.insertBefore(cmp, priceEl);
      }
      cmp.textContent = formatMoney(Number(compareRaw));
      if (wrap) wrap.classList.add('product-card__price--sale');
    } else {
      if (cmp) cmp.textContent = '';
      if (wrap) wrap.classList.remove('product-card__price--sale');
    }
  }

  function selectCardSwatch(sw) {
    var card = sw.closest(CARD);
    if (!card || swatchDisabled(sw)) return;
    var group = sw.closest('[data-product-swatches]') || card;
    $$('[data-swatch]', group).forEach(function (o) {
      o.classList.remove('is-selected');
      o.setAttribute('aria-checked', 'false');
      o.setAttribute('aria-pressed', 'false');
    });
    sw.classList.add('is-selected');
    sw.setAttribute('aria-checked', 'true');
    sw.setAttribute('aria-pressed', 'true');
    card.dataset.userSelected = '1';
    applyCardMedia(card, swatchMedia(sw));
    updateCardPrice(card, sw);
    // Carry the chosen variant into the card's product links.
    var url = sw.getAttribute('data-variant-url');
    if (url) {
      $$('[data-product-card-link]', card).forEach(function (a) { a.setAttribute('href', url); });
    }
  }

  function initProductCards(ctx) {
    $$(CARD, ctx || document).forEach(function (card) {
      if (card.dataset.cardBound) return;
      card.dataset.cardBound = '1';
      cacheCardMedia(card);
      // Warm the browser cache so hover previews don't flicker.
      $$('[data-swatch][data-variant-media]', card).forEach(function (sw) {
        var img = new Image();
        img.src = swatchMedia(sw);
      });
      // Guarantee a selected swatch for a11y even if Liquid marked none.
      if (!selectedCardSwatch(card)) {
        var first = card.querySelector('[data-swatch]:not([aria-disabled="true"])') ||
                    card.querySelector('[data-swatch]');
        if (first) { first.classList.add('is-selected'); first.setAttribute('aria-checked', 'true'); }
      }
      // Point the product links at the pre-selected colour's variant, so
      // clicking the card opens the product on the colour that's shown selected.
      var sel = selectedCardSwatch(card);
      var selUrl = sel && sel.getAttribute('data-variant-url');
      if (selUrl) {
        $$('[data-product-card-link]', card).forEach(function (a) { a.setAttribute('href', selUrl); });
      }
    });

    if (cardsDelegated) return;
    cardsDelegated = true;

    document.addEventListener('mouseover', function (e) {
      var sw = e.target.closest && e.target.closest('[data-swatch]');
      if (sw && sw.closest(CARD)) previewCardSwatch(sw);
    });
    document.addEventListener('mouseout', function (e) {
      var sw = e.target.closest && e.target.closest('[data-swatch]');
      if (!sw) return;
      var card = sw.closest(CARD);
      if (!card) return;
      // Moving to a sibling swatch: let that swatch's mouseover take over.
      var to = e.relatedTarget;
      if (to && to.closest && to.closest('[data-swatch]') && sw.closest('[data-product-swatches]') === (to.closest('[data-product-swatches]'))) return;
      endCardPreview(card);
    });
    document.addEventListener('focusin', function (e) {
      var sw = e.target.closest && e.target.closest('[data-swatch]');
      if (sw && sw.closest(CARD)) previewCardSwatch(sw);
    });
    document.addEventListener('focusout', function (e) {
      var sw = e.target.closest && e.target.closest('[data-swatch]');
      if (sw && sw.closest(CARD)) endCardPreview(sw.closest(CARD));
    });
    document.addEventListener('click', function (e) {
      var sw = e.target.closest && e.target.closest('[data-swatch]');
      if (sw && sw.closest(CARD)) { e.preventDefault(); selectCardSwatch(sw); }
    });
  }

  /* -------------------------------------------------------------------- */
  /* Product recommendations (Section Rendering API)                      */
  /* -------------------------------------------------------------------- */
  function initRecommendations(root) {
    var el = $('[data-product-recommendations]', root || document);
    if (!el || el.dataset.loaded || !el.dataset.url) return;
    el.dataset.loaded = '1';
    fetch(el.dataset.url).then(function (r) { return r.text(); }).then(function (text) {
      var doc = new DOMParser().parseFromString(text, 'text/html');
      var fresh = doc.querySelector('[data-product-recommendations] .shell');
      if (fresh) el.innerHTML = fresh.outerHTML;
    }).catch(function () {});
  }

  /* -------------------------------------------------------------------- */
  /* Collection facets                                                    */
  /* -------------------------------------------------------------------- */
  function initFacets(root) {
    var form = $('[data-facets-form]', root || document);
    if (!form || form.dataset.bound) return;
    form.dataset.bound = '1';
    var section = form.closest('[data-section-type="collection"]');

    function apply() {
      var params = new URLSearchParams(new FormData(form));
      // strip empty
      var clean = new URLSearchParams();
      params.forEach(function (v, k) { if (v !== '') clean.append(k, v); });
      var url = window.location.pathname + '?' + clean.toString();
      fetch(url).then(function (r) { return r.text(); }).then(function (text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var freshResults = doc.querySelector('[data-collection-results]');
        var curResults = $('[data-collection-results]', section);
        if (freshResults && curResults) curResults.innerHTML = freshResults.innerHTML;
        var freshCount = doc.querySelector('[data-visible-count]');
        var curCount = $('[data-visible-count]', section);
        if (freshCount && curCount) curCount.textContent = freshCount.textContent;
        if (history.pushState) history.pushState({}, '', url);
      }).catch(function () { form.submit(); });
    }

    form.addEventListener('change', apply);
    form.addEventListener('submit', function (e) { e.preventDefault(); apply(); });
  }

  /* -------------------------------------------------------------------- */
  /* Predictive search                                                    */
  /* -------------------------------------------------------------------- */
  function initPredictiveSearch() {
    var input = $('[data-predictive-search-input]');
    var results = $('[data-predictive-search]');
    if (!input || !results || input.dataset.bound || !routes.predictiveSearch) return;
    input.dataset.bound = '1';
    var timer;
    input.addEventListener('input', function () {
      clearTimeout(timer);
      var q = input.value.trim();
      if (q.length < 2) { results.hidden = true; results.innerHTML = ''; return; }
      timer = setTimeout(function () {
        var url = routes.predictiveSearch + '?q=' + encodeURIComponent(q) + '&resources[type]=product,article&resources[limit]=5&section_id=predictive-search';
        fetch(routes.predictiveSearch + '.json?q=' + encodeURIComponent(q) + '&resources[type]=product,article&resources[limit]=5')
          .then(function (r) { return r.json(); })
          .then(function (data) { renderPredictive(data, results); })
          .catch(function () {});
      }, 220);
    });
  }

  function renderPredictive(data, container) {
    var items = [];
    if (data.resources && data.resources.results) {
      (data.resources.results.products || []).forEach(function (p) {
        var img = (p.featured_image && p.featured_image.url) || p.image || '';
        items.push('<li class="predictive-search__item"><a href="' + p.url + '"><span class="predictive-search__image">' + (img ? '<img src="' + img + '" alt="" width="44" height="44">' : '') + '</span><span>' + p.title + '</span></a></li>');
      });
      (data.resources.results.articles || []).forEach(function (a) {
        items.push('<li class="predictive-search__item"><a href="' + a.url + '"><span>' + a.title + '</span></a></li>');
      });
    }
    container.innerHTML = items.length ? '<ul class="predictive-search__results">' + items.join('') + '</ul>' : '';
    container.hidden = items.length === 0;
  }

  /* -------------------------------------------------------------------- */
  /* Share                                                                */
  /* -------------------------------------------------------------------- */
  function initShare(root) {
    $$('[data-share-button]', root || document).forEach(function (btn) {
      if (btn.dataset.bound) return;
      btn.dataset.bound = '1';
      btn.addEventListener('click', function () {
        var url = btn.dataset.shareUrl;
        var title = btn.dataset.shareTitle;
        if (navigator.share) { navigator.share({ title: title, url: url }).catch(function () {}); }
        else if (navigator.clipboard) { navigator.clipboard.writeText(url); announce('Link copied'); }
      });
    });
  }

  /* -------------------------------------------------------------------- */
  /* Scroll-scrub hero video (ported from prototype)                      */
  /* -------------------------------------------------------------------- */
  function initScrollScrubHeroVideo() {
    var video = $('[data-scroll-scrub-video]');
    var hero = video && video.closest('.home-hero-full');
    if (!video || !hero || video.dataset.bound) return;
    video.dataset.bound = '1';

    // Reduced motion: leave the poster image in place, no video motion.
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || document.documentElement.dataset.motion === 'off') return;

    // Touch / coarse-pointer devices (phones, tablets): scrubbing a paused video
    // via currentTime does not paint frames on iOS Safari (the hero went grey).
    // Play it normally (muted + looping) and only reveal it once it is actually
    // playing, so the vertical poster stays visible until real frames render.
    if (window.matchMedia('(max-width: 760px), (hover: none), (pointer: coarse)').matches) {
      // Mobile: keep the static poster (the hero's first frame). iOS can't paint
      // a scroll-scrubbed video, and an autoplay loop adds motion the desktop
      // doesn't have, so on phones the hero stays a clean still. Don't reveal the
      // video (poster keeps showing) and avoid downloading it.
      video.pause();
      video.preload = 'none';
      return;
    }

    var isReady = isFinite(video.duration) && video.duration > 0;
    var frameRequest = 0;
    function clamp(v) { return Math.min(1, Math.max(0, v)); }
    function sync() {
      frameRequest = 0;
      if (!isReady) return;
      var rect = hero.getBoundingClientRect();
      var progress = clamp(-rect.top / Math.max(rect.height, 1));
      var duration = Math.max(video.duration - 0.033, 0);
      var next = duration * progress;
      if (Math.abs(video.currentTime - next) > 0.025) video.currentTime = next;
    }
    function request() { if (!frameRequest) frameRequest = requestAnimationFrame(sync); }
    function markReady() { isReady = true; video.pause(); hero.classList.add('is-video-ready'); request(); }
    video.pause();
    if (isReady) markReady(); else video.addEventListener('loadedmetadata', markReady, { once: true });
    window.addEventListener('scroll', request, { passive: true });
    window.addEventListener('resize', request);
    request();
  }

  /* -------------------------------------------------------------------- */
  /* Header scroll state (animated white bar wipes down once scrolled)    */
  /* -------------------------------------------------------------------- */
  function initHeaderScroll() {
    var header = $('.site-header');
    if (!header || header.dataset.scrollBound) return;
    header.dataset.scrollBound = '1';
    var ticking = false;
    function apply() {
      ticking = false;
      header.classList.toggle('site-header--scrolled', window.pageYOffset > 8);
    }
    function onScroll() {
      if (!ticking) { ticking = true; requestAnimationFrame(apply); }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    apply();
  }

  /* -------------------------------------------------------------------- */
  /* Marquee: keep the scrolling text seamless (never an empty gap).      */
  /* The CSS loop shifts by one group and swaps in the next, which only   */
  /* stays gap-free while one group is at least as wide as the viewport.  */
  /* Short text on a wide screen leaves a blank stretch, so here we clone */
  /* the group until the track overflows and tell the keyframe how many   */
  /* copies there are (--marquee-copies) so it still shifts by one group. */
  /* -------------------------------------------------------------------- */
  function initMarquee(ctx) {
    $$('.footer-marquee', ctx).forEach(function (marquee) {
      if (marquee.dataset.marqueeBound) return;
      marquee.dataset.marqueeBound = '1';

      // Reduced motion / motion off: CSS shows a single static group, no loop.
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches
        || document.documentElement.dataset.motion === 'off') return;

      var viewport = marquee.querySelector('.footer-marquee__viewport');
      var track = marquee.querySelector('.footer-marquee__track');
      var master = track && track.querySelector('.footer-marquee__group');
      if (!viewport || !track || !master) return;
      var masterHTML = master.innerHTML; // clone source, so rebuilds never compound

      function build() {
        if (!marquee.isConnected) return;
        track.innerHTML = '';
        var first = document.createElement('div');
        first.className = 'footer-marquee__group';
        first.innerHTML = masterHTML;
        track.appendChild(first);

        var groupW = first.offsetWidth;
        var viewW = viewport.clientWidth;
        // How many copies until shifting by one group still covers the viewport:
        // (copies - 1) groups must span it. Fall back to 2 before layout is ready.
        var copies = (groupW > 0 && viewW > 0) ? Math.max(2, Math.ceil(viewW / groupW) + 1) : 2;
        for (var i = 1; i < copies; i++) {
          var clone = first.cloneNode(true);
          clone.setAttribute('aria-hidden', 'true');
          track.appendChild(clone);
        }
        marquee.style.setProperty('--marquee-copies', String(copies));
      }

      build();

      // Both content width (fonts) and viewport width change how many copies
      // are needed, so recompute after fonts load and on resize (debounced).
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(build);
      var resizeTimer;
      window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(build, 150);
      });
    });
  }

  /* -------------------------------------------------------------------- */
  /* Product image lightbox                                               */
  /* Opens from any gallery image, builds its slides from the currently   */
  /* visible images (so it tracks the variant filter and single/multi     */
  /* state), and follows the storefront-panel conventions: rAF reveal,    */
  /* body scroll lock, focus trap, ESC / backdrop close, focus return.    */
  /* Desktop: click-to-zoom with move-to-pan. Touch: pinch-zoom, drag to  */
  /* pan, swipe to page, double-tap to toggle zoom.                       */
  /* -------------------------------------------------------------------- */
  function initLightbox(ctx) {
    $$('[data-lightbox]', ctx).forEach(function (lb) {
      if (lb.dataset.lightboxBound) return;
      lb.dataset.lightboxBound = '1';

      var product = lb.closest('[data-product-root]') || document;
      var dialog = lb.querySelector('[data-lightbox-dialog]');
      var viewport = lb.querySelector('[data-lightbox-viewport]');
      var track = lb.querySelector('[data-lightbox-track]');
      var counter = lb.querySelector('[data-lightbox-counter]');
      var prevBtn = lb.querySelector('[data-lightbox-prev]');
      var nextBtn = lb.querySelector('[data-lightbox-next]');
      var closeBtn = lb.querySelector('[data-lightbox-closebtn]');
      if (!dialog || !viewport || !track) return;

      var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
      var MAX_SCALE = 4;
      var slides = [];
      var index = 0;
      var isOpen = false;
      var hideTimer = null;
      var returnFocus = null;

      /* ---- slide construction ------------------------------------------ */
      function triggersInDom() {
        return $$('.media-card', product).filter(function (fig) {
          return !fig.hidden && fig.querySelector('[data-zoom-open]');
        }).map(function (fig) { return fig.querySelector('[data-zoom-open]'); });
      }

      function buildSlides(triggers) {
        track.innerHTML = '';
        slides = triggers.map(function (t) {
          var slide = document.createElement('figure');
          slide.className = 'pdp-lightbox__slide';
          var img = document.createElement('img');
          img.className = 'pdp-lightbox__img';
          img.alt = t.getAttribute('data-zoom-alt') || '';
          img.decoding = 'async';
          img.draggable = false;
          img.dataset.src = t.getAttribute('data-zoom-src') || '';
          img.dataset.srcset = t.getAttribute('data-zoom-srcset') || '';
          slide.appendChild(img);
          track.appendChild(slide);
          return { slide: slide, img: img, scale: 1, tx: 0, ty: 0, loaded: false };
        });
      }

      function loadSlide(i) {
        var s = slides[i];
        if (!s || s.loaded) return;
        if (s.img.dataset.srcset) { s.img.sizes = '100vw'; s.img.srcset = s.img.dataset.srcset; }
        if (s.img.dataset.src) s.img.src = s.img.dataset.src;
        s.loaded = true;
      }

      /* ---- transform helpers ------------------------------------------- */
      function applyTransform(s, settle) {
        s.img.style.transition = settle ? 'transform var(--lb-dur) var(--lb-ease)' : 'none';
        s.img.style.transform = 'translate(' + s.tx + 'px,' + s.ty + 'px) scale(' + s.scale + ')';
        s.slide.classList.toggle('is-zoomed', s.scale > 1.02);
      }
      function clampPan(s) {
        var vpW = viewport.clientWidth, vpH = viewport.clientHeight;
        var baseW = s.img.clientWidth, baseH = s.img.clientHeight;
        var maxX = Math.max(0, (baseW * s.scale - vpW) / 2);
        var maxY = Math.max(0, (baseH * s.scale - vpH) / 2);
        s.tx = Math.min(maxX, Math.max(-maxX, s.tx));
        s.ty = Math.min(maxY, Math.max(-maxY, s.ty));
      }
      function resetZoom(i, settle) {
        var s = slides[i];
        if (!s) return;
        s.scale = 1; s.tx = 0; s.ty = 0;
        applyTransform(s, settle);
      }
      function zoomTo(i, scale, focalX, focalY) {
        var s = slides[i];
        if (!s) return;
        var rect = viewport.getBoundingClientRect();
        var fx = (focalX == null ? rect.width / 2 : focalX - rect.left) - rect.width / 2;
        var fy = (focalY == null ? rect.height / 2 : focalY - rect.top) - rect.height / 2;
        var prev = s.scale;
        s.scale = Math.min(MAX_SCALE, Math.max(1, scale));
        s.tx = fx - (fx - s.tx) * (s.scale / prev);
        s.ty = fy - (fy - s.ty) * (s.scale / prev);
        clampPan(s);
        applyTransform(s, true);
      }

      /* ---- paging ------------------------------------------------------ */
      function goTo(i, animate) {
        index = Math.max(0, Math.min(i, slides.length - 1));
        track.classList.toggle('is-animating', !!animate);
        track.style.transform = 'translateX(' + (-index * 100) + '%)';
        slides.forEach(function (s, si) { if (si !== index) resetZoom(si, false); });
        loadSlide(index); loadSlide(index + 1); loadSlide(index - 1);
        updateChrome();
      }
      function updateChrome() {
        var n = slides.length;
        if (counter) counter.textContent = (index + 1) + ' / ' + n;
        if (prevBtn) prevBtn.disabled = index <= 0;
        if (nextBtn) nextBtn.disabled = index >= n - 1;
      }

      /* ---- open / close ------------------------------------------------ */
      function open(startIndex) {
        var triggers = triggersInDom();
        if (!triggers.length) return;
        buildSlides(triggers);
        index = Math.max(0, Math.min(startIndex || 0, slides.length - 1));
        lb.classList.toggle('is-single', slides.length <= 1);
        returnFocus = document.activeElement;
        clearTimeout(hideTimer);
        lb.hidden = false;
        lb.setAttribute('aria-hidden', 'false');
        document.body.classList.add('is-lightbox-open');
        goTo(index, false);
        isOpen = true;
        requestAnimationFrame(function () {
          lb.classList.add('is-open');
          setTimeout(function () { if (closeBtn) closeBtn.focus(); }, 80);
        });
      }
      function close() {
        if (!isOpen) return;
        isOpen = false;
        lb.classList.remove('is-open');
        lb.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('is-lightbox-open');
        var rf = returnFocus;
        hideTimer = setTimeout(function () {
          lb.hidden = true;
          track.innerHTML = '';
          slides = [];
        }, 320);
        if (rf && rf.focus) rf.focus();
      }

      /* ---- open triggers (gallery images) ------------------------------ */
      product.addEventListener('click', function (e) {
        var t = e.target.closest('[data-zoom-open]');
        if (!t || !product.contains(t)) return;
        e.preventDefault();
        var triggers = triggersInDom();
        var i = triggers.indexOf(t);
        open(i < 0 ? 0 : i);
      });

      /* ---- control clicks / close zones -------------------------------- */
      lb.addEventListener('click', function (e) {
        if (e.target.closest('[data-lightbox-close]')) { close(); return; }
        if (e.target.closest('[data-lightbox-prev]')) { goTo(index - 1, true); return; }
        if (e.target.closest('[data-lightbox-next]')) { goTo(index + 1, true); return; }
        // Desktop only: click the picture to toggle a close-up, click the
        // surrounding scrim to dismiss.
        if (!finePointer.matches) return;
        var s = slides[index];
        if (s && e.target === s.img) {
          if (s.scale > 1.02) resetZoom(index, true);
          else zoomTo(index, 2.4, e.clientX, e.clientY);
        } else if (e.target.closest('.pdp-lightbox__slide')) {
          close();
        }
      });

      // Desktop move-to-pan while zoomed.
      viewport.addEventListener('mousemove', function (e) {
        if (!finePointer.matches) return;
        var s = slides[index];
        if (!s || s.scale <= 1.02) return;
        var rect = viewport.getBoundingClientRect();
        var rx = (e.clientX - rect.left) / rect.width;
        var ry = (e.clientY - rect.top) / rect.height;
        var baseW = s.img.clientWidth, baseH = s.img.clientHeight;
        s.tx = (0.5 - rx) * Math.max(0, baseW * s.scale - rect.width);
        s.ty = (0.5 - ry) * Math.max(0, baseH * s.scale - rect.height);
        applyTransform(s, false);
      });

      /* ---- keyboard: ESC, arrows, focus trap --------------------------- */
      document.addEventListener('keydown', function (e) {
        if (!isOpen) return;
        if (e.key === 'Escape') { e.preventDefault(); close(); return; }
        if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(index - 1, true); return; }
        if (e.key === 'ArrowRight') { e.preventDefault(); goTo(index + 1, true); return; }
        if (e.key !== 'Tab') return;
        var focusable = $$('button:not([disabled])', dialog).filter(function (el) {
          return el.offsetParent !== null && el.getAttribute('tabindex') !== '-1';
        });
        if (!focusable.length) return;
        var first = focusable[0], last = focusable[focusable.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      });

      /* ---- touch: pinch-zoom, pan, swipe, double-tap ------------------- */
      var touch = {
        mode: null,      // 'swipe' | 'pan' | 'pinch'
        startX: 0, startY: 0, lastX: 0, lastY: 0,
        dist0: 0, scale0: 1, tx0: 0, ty0: 0, fx: 0, fy: 0,
        lastTap: 0, lastTapX: 0, lastTapY: 0, moved: false
      };
      function dist(t1, t2) {
        var dx = t1.clientX - t2.clientX, dy = t1.clientY - t2.clientY;
        return Math.hypot(dx, dy);
      }

      viewport.addEventListener('touchstart', function (e) {
        var s = slides[index];
        if (!s) return;
        if (e.touches.length === 2) {
          touch.mode = 'pinch';
          touch.dist0 = dist(e.touches[0], e.touches[1]);
          touch.scale0 = s.scale; touch.tx0 = s.tx; touch.ty0 = s.ty;
          var rect = viewport.getBoundingClientRect();
          touch.fx = (e.touches[0].clientX + e.touches[1].clientX) / 2 - rect.left - rect.width / 2;
          touch.fy = (e.touches[0].clientY + e.touches[1].clientY) / 2 - rect.top - rect.height / 2;
          s.img.style.transition = 'none';
        } else if (e.touches.length === 1) {
          var t = e.touches[0];
          touch.startX = touch.lastX = t.clientX;
          touch.startY = touch.lastY = t.clientY;
          touch.moved = false;
          touch.mode = s.scale > 1.02 ? 'pan' : 'swipe';
          if (touch.mode === 'swipe') track.classList.remove('is-animating');
          s.img.style.transition = 'none';
        }
      }, { passive: true });

      viewport.addEventListener('touchmove', function (e) {
        var s = slides[index];
        if (!s || !touch.mode) return;
        if (touch.mode === 'pinch' && e.touches.length >= 2) {
          e.preventDefault();
          var d = dist(e.touches[0], e.touches[1]);
          var next = Math.min(MAX_SCALE, Math.max(1, touch.scale0 * (d / (touch.dist0 || 1))));
          s.scale = next;
          s.tx = touch.fx - (touch.fx - touch.tx0) * (next / touch.scale0);
          s.ty = touch.fy - (touch.fy - touch.ty0) * (next / touch.scale0);
          clampPan(s);
          applyTransform(s, false);
          return;
        }
        var t = e.touches[0];
        var dx = t.clientX - touch.startX, dy = t.clientY - touch.startY;
        if (Math.abs(dx) > 6 || Math.abs(dy) > 6) touch.moved = true;
        if (touch.mode === 'pan') {
          e.preventDefault();
          s.tx += t.clientX - touch.lastX;
          s.ty += t.clientY - touch.lastY;
          touch.lastX = t.clientX; touch.lastY = t.clientY;
          clampPan(s);
          applyTransform(s, false);
        } else if (touch.mode === 'swipe') {
          // Only hijack once the gesture is clearly horizontal.
          if (Math.abs(dx) < Math.abs(dy)) return;
          e.preventDefault();
          var resist = ((index === 0 && dx > 0) || (index === slides.length - 1 && dx < 0)) ? 0.35 : 1;
          track.style.transform = 'translateX(calc(' + (-index * 100) + '% + ' + (dx * resist) + 'px))';
        }
      }, { passive: false });

      viewport.addEventListener('touchend', function (e) {
        var s = slides[index];
        if (!s) return;
        if (touch.mode === 'pinch') {
          if (s.scale <= 1.02) resetZoom(index, true);
          else { clampPan(s); applyTransform(s, true); }
          touch.mode = e.touches.length ? 'pan' : null;
          return;
        }
        if (touch.mode === 'swipe') {
          var dx = e.changedTouches[0].clientX - touch.startX;
          var threshold = viewport.clientWidth * 0.18;
          if (dx <= -threshold && index < slides.length - 1) goTo(index + 1, true);
          else if (dx >= threshold && index > 0) goTo(index - 1, true);
          else goTo(index, true);
        }
        // Tap handling (negligible move): double-tap to toggle zoom on the
        // image, single tap on the scrim to dismiss.
        if (!touch.moved) {
          var now = Date.now();
          var onImg = e.target === s.img;
          if (onImg && now - touch.lastTap < 300 &&
              Math.abs(e.changedTouches[0].clientX - touch.lastTapX) < 30 &&
              Math.abs(e.changedTouches[0].clientY - touch.lastTapY) < 30) {
            if (s.scale > 1.02) resetZoom(index, true);
            else zoomTo(index, 2.5, e.changedTouches[0].clientX, e.changedTouches[0].clientY);
            touch.lastTap = 0;
          } else if (onImg) {
            touch.lastTap = now;
            touch.lastTapX = e.changedTouches[0].clientX;
            touch.lastTapY = e.changedTouches[0].clientY;
          } else if (e.target.closest('.pdp-lightbox__slide')) {
            close();
          }
        }
        touch.mode = null;
      }, { passive: true });

      /* ---- keep geometry sane on resize / rotate ----------------------- */
      var rt;
      window.addEventListener('resize', function () {
        if (!isOpen) return;
        clearTimeout(rt);
        rt = setTimeout(function () {
          var s = slides[index];
          if (s) { clampPan(s); applyTransform(s, false); }
          goTo(index, false);
        }, 150);
      });
    });
  }

  /* -------------------------------------------------------------------- */
  /* Init                                                                 */
  /* -------------------------------------------------------------------- */
  function initAll(ctx) {
    initOverlayTriggers();
    initOverlayEvents();
    initAddToCartForms();
    initCartPage();
    initQuantitySteppers(ctx);
    initProduct(ctx);
    initProductCards(ctx);
    initRecommendations(ctx);
    initFacets(ctx);
    initPredictiveSearch();
    initShare(ctx);
    initScrollScrubHeroVideo();
    initHeaderScroll();
    initMarquee(ctx);
    initLightbox(ctx);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  // Theme Editor section lifecycle
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:unload', function () { closePanel(); });
  document.addEventListener('shopify:block:select', function (e) {
    var product = e.target.closest('[data-product-root]');
    if (product) { /* could open accordion */ }
    var details = e.target.closest('details');
    if (details) details.open = true;
  });
  document.addEventListener('shopify:block:deselect', function () {});
})();
